module.exports = __webpack_public_path__ + "img/良好口碑.742584d7.jpg";